export default {
    "dashboard.title": "D*shbo*rd",
    "auth.signIn.form.title": "Charaftna",
    "auth.signIn.panel.title": "Chaklak jdid hon",
    "auth.signUp.form.title": "Same3na",
    "auth.signUp.panel.title": "wahad mena ?",
    "splashScreen.title": "L***",
    "dashboard.header.btn.submitGame": "Submit Game",
    "dashboard.submitGameDialog.gameStep.title": "Add your game session",
    "dashboard.submitGameDialog.gameStep.cta.button": "Submit Game!"
}